<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Basic Profile
  </div>
  <div class="">
    <form nz-form [formGroup]="basicProfileForm" (ngSubmit)="submitForm()">
      <div class="form-row" style="margin-left: 12px">
        <div class="col-md-4">
           <div class="col-md-12"><nz-form-label nzRequired>Name of STP</nz-form-label></div>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="20" nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl" disabled>
                <input nz-input formControlName="stpName" placeholder="Name of STP" [(ngModel)]="stpName" readonly />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
           <div class="col-md-12"><nz-form-label nzRequired> Name of STP in Bangla</nz-form-label></div>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="20" nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl" disabled>
                <input nz-input formControlName="stpNameBangla" placeholder="STP Name Bangla" />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input stp name (bangla)!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">
                    Please input valid stp name (bangla)!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>



        <div class=" col-md-4">
          <div class="form-row" style="margin-left: 28px">
           <div class="col-md-12"><nz-form-label nzRequired> Type of STP</nz-form-label></div>
          <div class="col-md-12">
            <nz-form-item>
             <nz-form-control  nzErrorTip="Please select STP type">
                <nz-select id="stpTypeId" nzShowSearch nzAllowClear formControlName="stpTypeId"
                  nzPlaceHolder="Select STP Type" class="row">
                  <nz-option *ngFor="let stpType of stptypes" [nzValue]="stpType.id" [nzLabel]="stpType.typeName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        </div>





      </div>



      <div class="form-row" style="margin-left: 28px">
        <div class=" col-md-4">
          <nz-form-label nzRequired>Type of Ownership</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select STP Owner type">
                <nz-select id="stpOwnershipTypeId" nzShowSearch nzAllowClear formControlName="stpOwnershipTypeId"
                  nzPlaceHolder="Select STP Ownership Type" class="row"
                  (ngModelChange)="setStpMinistriesByOwnerShipId()">
                  <nz-option *ngFor="let stpOwnershipType of stpOwnershipTypes" [nzValue]="stpOwnershipType.id"
                    [nzLabel]="stpOwnershipType.typeName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired>Name of Ministry/ Division</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select name of Ministry/ Division">
                <nz-select id="stpMinistryId" nzShowSearch nzAllowClear formControlName="stpMinistryId"
                  nzPlaceHolder="Select Ministry" class="row" (ngModelChange)="setAgencyByMinId()">
                  <nz-option *ngFor="let ministry of stpMinistries" [nzValue]="ministry.id"
                    [nzLabel]="ministry.ministryName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired>Name of Agency</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select name of Agency">
                <nz-select id="stpAgencyId" nzShowSearch nzAllowClear formControlName="stpAgencyId"
                  nzPlaceHolder="Select Agency" class="row">
                  <nz-option *ngFor="let agency of stpAgencies" [nzValue]="agency.id" [nzLabel]="agency.agencyName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 28px">
        <div class=" col-md-4">
          <nz-form-label nzRequired>Year of Establishment</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzHasFeedback nzErrorTip="Please choose establish year">
                <nz-date-picker
                [nzDisabledDate]="disabledDate" nzMode="year" id="establishYear" formControlName="establishYear" placeholder="Date"
                  class="row">
                </nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired> Location of the STP</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select name of location">
                <nz-select id="stpLocationId" nzShowSearch nzAllowClear formControlName="stpLocationId"
                  nzPlaceHolder="Select Location" class="row" (ngModelChange)="setCountriesByLocationTypeId()">
                  <nz-option *ngFor="let location of stpLocations" [nzValue]="location.id"
                    [nzLabel]="location.locationName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <b style="margin-left: 10px">Address of the Organization</b>
      <hr />

      <div class="form-row" style="margin-left: 28px">
        <div class=" col-md-4">
          <nz-form-label nzRequired> Country</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select name of country">
                <nz-select id="stpCountryId" nzShowSearch nzAllowClear formControlName="stpCountryId"
                  nzPlaceHolder="Select Country" class="row" (ngModelChange)="setDivisionByCountryId()">
                  <nz-option *ngFor="let country of sysCountries" [nzValue]="country.id"
                    [nzLabel]="country.countryName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired>Division/State</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select Division/State">
                <nz-select id="division_id" nzShowSearch nzAllowClear formControlName="stpDivisionId"
                  nzPlaceHolder="Select Division" class="row" (ngModelChange)="setDistrictInformation()">
                  <nz-option *ngFor="let division of divisions" [nzValue]="division.id"
                    [nzLabel]="division.divisionName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired>District/ City</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select District/ City">
                <nz-select id="district_id" nzShowSearch nzAllowClear formControlName="stpDistrictId"
                  nzPlaceHolder="Select District" class="row" (ngModelChange)="setStpUpazillaInformation()">
                  <nz-option *ngFor="let district of districts" [nzValue]="district.id"
                    [nzLabel]="district.districtName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 28px">
        <div class=" col-md-4">
          <nz-form-label nzRequired> Upazilla/Sub-district</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzErrorTip="Please select name of Upazilla">
                <nz-select id="upazilla_id" nzShowSearch nzAllowClear formControlName="stpUpazillaId"
                  nzPlaceHolder="Select Upazilla" class="row">
                  <nz-option *ngFor="let upazilla of upazilas" [nzValue]="upazilla.id"
                    [nzLabel]="upazilla.upazillaName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <nz-form-label nzRequired>Post Office</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <textarea nz-input style="margin-left: -17px" formControlName="postOffice" placeholder="Post Office"
                  nzAutosize></textarea>

                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input post office!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <!-- <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="20" nzErrorTip="Please select Post office">
                <nz-select id="stpPostOfficeId" nzShowSearch nzAllowClear formControlName="stpPostOfficeId"
                  nzPlaceHolder="Select Post Office" class="row">
                  <nz-option *ngFor="let postOffice of sysPostOffices" [nzValue]="postOffice.id"
                    [nzLabel]="postOffice.locationName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div> -->
        </div>
        <div class=" col-md-4">
          <div class=" col-md-12"><nz-form-label nzRequired>House, Road, Village Area</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <textarea nz-input style="margin-left: -17px" formControlName="address" placeholder="Address"
                  nzAutosize></textarea>

                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 12px">
        <div class=" col-md-4">
           <div class=" col-md-12"><nz-form-label nzRequired> Contact Number</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control  nzHasFeedback [nzErrorTip]="contactNoErrorTpl">
                <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                  <ng-template #addOnBeforeTemplate>
                    <nz-select formControlName="contactNumberPrefixForContactNo" class="phone-select">
                      <nz-option nzLabel="+880" nzValue="+880"></nz-option>
                    </nz-select>
                  </ng-template>
                  <input formControlName="contactNo" id="contactNo" placeholder="Contact Number" nz-input />
                </nz-input-group>
                <ng-template #contactNoErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input contact number!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('maxlength')">
                    Max Length Reached
                  </ng-container>
                  <ng-container *ngIf="control.hasError('minlength')">
                    Contact Number Must be 10 digit
                  </ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">
                    <div>Only Valid Digits are allowed</div>
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4" style="margin-left: 18px">
          <div class=" col-md-12"><nz-form-label nzRequired> Email Address</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="emailErrorTpl">
                <input nz-input style="margin-left: -13px" formControlName="email" placeholder="E-mail" />
                <ng-template #emailErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('email')">
                    The input is not valid E-mail!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input your E-mail!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <b style="margin-left: 10px">Owner/Principal/Head of the STP</b>
      <hr />
      <div class="form-row" style="margin-left: 12px">
        <div class=" col-md-4">
          <div class=" col-md-12"><nz-form-label nzRequired>Name</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <input nz-input formControlName="contactName" placeholder="Name" />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
           <div class=" col-md-12"><nz-form-label nzRequired> Designation</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <input nz-input formControlName="contactDesignation" placeholder="Designation" />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input designation!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <div class=" col-md-12"><nz-form-label nzRequired> Contact Number</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="contactNumberErrorTpl">
                <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                  <ng-template #addOnBeforeTemplate>
                    <nz-select formControlName="contactNumberPrefixForContactNumber" class="phone-select">
                      <nz-option nzLabel="+880" nzValue="+880"></nz-option>
                    </nz-select>
                  </ng-template>
                  <input formControlName="contactNumber" id="contactNumber" placeholder="Contact Number" nz-input />
                </nz-input-group>
                <ng-template #contactNumberErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input your contact number!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('maxlength')">
                    Max Length Reached
                  </ng-container>
                  <ng-container *ngIf="control.hasError('minlength')">
                    Contact Number Must be 10 digit
                  </ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">
                    <div>Only Valid Digits are allowed</div>
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4">
          <div class=" col-md-12"><nz-form-label nzRequired> Contact Email</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="emailErrorTpl">
                <input nz-input formControlName="contactEmail" placeholder="E-mail" type="email" />
                <ng-template #emailErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('email')">
                    The input is not valid E-mail!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input your E-mail!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <b style="margin-left: 10px">Managing Committee</b>
      <hr />

      <div class="form-row" style="margin-left: 12px">
        <div class="col-md-4">
          <nz-form-label nzRequired>Is there any committee?</nz-form-label>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="committeeErrorTpl">
                <nz-radio-group formControlName="isCommittee">
                  <label nz-radio [nzValue]="true" (click)="setVisibilityOfCommittee()">Yes</label>
                  <label nz-radio [nzValue]="false" (click)="setVisibilityOfCommittee()">No</label>
                </nz-radio-group>
                <ng-template #committeeErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please select Committee!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4" *ngIf="stpIsCommittee">
          <div class="col-md-12"><nz-form-label nzRequired> Total Member</nz-form-label></div>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="22" nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <input nz-input type="number" formControlName="totalMember" placeholder="Committee Total Member" />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input total member!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('min')">
                    Total member can not be negative!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class=" col-md-4" *ngIf="stpIsCommittee">
          <div class=" col-md-12"><nz-form-label nzRequired> Total Female Member</nz-form-label></div>
          <div class=" col-md-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="22" nzHasFeedback nzValidatingTip="Validating..."
                [nzErrorTip]="basicProfileErrorTpl">
                <input nz-input type="number" formControlName="totalFemaleMember" placeholder="Total Female Member" />
                <ng-template #basicProfileErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input total female member!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('min')">
                    Total female member can not be negative!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('duplicated')">
                    This data is redundant!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 20px" *ngIf="stpIsCommittee">
        <div class=" col-md-4">
          <div class=" col-md-12"><nz-form-label nzRequired>Date of Approval of the Committee</nz-form-label></div>
          <div class=" col-md-10">
            <nz-form-control  nzHasFeedback [nzErrorTip]="approvalDateCommitteeErrorTpl">
              <nz-date-picker [nzDisabledDate]="disabledStartDate" [(ngModel)]="startValue"
                (nzOnOpenChange)="handleStartOpenChange($event)" nzFormat="yyyy-MM-dd" id="approvalDateCommittee"
                formControlName="approvalDateCommittee" placeholder="Date" class="row">
              </nz-date-picker>
              <ng-template #approvalDateCommitteeErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid date!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </div>
        </div>

        <div class=" col-md-4" style="margin-left: 10px">
           <div class=" col-md-12"><nz-form-label nzRequired>Date of Expiry of the Committee</nz-form-label></div>
          <div class=" col-md-10">
            <nz-form-control  nzHasFeedback [nzErrorTip]="expirationDateCommitteeErrorTpl">
              <nz-date-picker #endDatePicker nzFormat="yyyy-MM-dd" [nzDisabledDate]="disabledEndDate"
                [(ngModel)]="endValue" id="expirationDateCommittee" formControlName="expirationDateCommittee"
                placeholder="Date" class="row">
              </nz-date-picker>
              <ng-template #expirationDateCommitteeErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid date!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </div>
        </div>
      </div>

      <!-- <div class="container">
        <div class="row justify-content-md-center">
          <div class="col col-lg-2">
            <button nz-button nzShape="round" nzType="primary" style="margin-right: 11px" nz-popconfirm
              nzPopconfirmTitle="Are you sure?" (nzOnConfirm)="previousPage()" (nzOnCancel)="cancel()">
              <i nz-icon nzType="backward" nzTheme="fill"></i> Previous
            </button>
          </div>
          <div class="col col-lg-2">
            <button nz-button nzShape="round" type="submit" nzType="primary" [disabled]="!basicProfileForm.valid">
              <i nz-icon nzType="save" nzTheme="fill"></i>Save
            </button>
          </div>

          &nbsp;

          <div class="col col-lg-2">
            <button nz-button nzShape="round" type="reset" nzType="primary" nzDanger (click)="resetForm()"
              style="margin-left: 11px">
              Reset
            </button>
          </div>
          &nbsp; &nbsp;

          <div class="col col-lg-2">
            <button nz-button nzShape="round" nzType="primary" nz-popconfirm nzPopconfirmTitle="Are you sure?"
              (nzOnConfirm)="nextPage()" (nzOnCancel)="cancel()">
              <i nz-icon nzType="forward" nzTheme="fill"></i> Next
            </button>
          </div>
        </div>
      </div> -->


      <div class="row justify-content-center media-button mt-4">


        <!-- <div class="col-xs-6 col-sm-2">
          <button type="button" class="btn btn-info active btn-lg btn-block cari border-redius" nz-popconfirm
            nzPopconfirmTitle="Are you sure?" (nzOnConfirm)="previousPage()" (nzOnCancel)="cancel()"> <i nz-icon
              nzType="backward" nzTheme="fill"></i> Previous
          </button>
        </div> -->
        <div class="col-xs-6 col-sm-2 mt-2">
          <button *ngIf="!isExist" type="submit" class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!basicProfileForm.valid"><i nz-icon nzType="save" nzTheme="fill"></i> Save</button>
          <button *ngIf="isExist" type="submit" class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!basicProfileForm.valid"><i nz-icon nzType="save" nzTheme="fill"></i> Update</button>
        </div>
        <div class="col-xs-6 col-sm-2 mt-2">
          <button type="button" class="btn btn-danger active btn-lg btn-block cari border-redius"
            (click)="resetForm()"><i nz-icon nzType="redo" nzTheme="outline"></i> Reset</button>
        </div>
        <div class="col-xs-6 col-sm-2 mt-2">
          <button type="button" class="btn btn-primary active btn-lg btn-block cari border-redius" nz-popconfirm
            nzPopconfirmTitle="Are you sure?" (nzOnConfirm)="nextPage()" (nzOnCancel)="cancel()"> <i nz-icon
              nzType="forward" nzTheme="fill"></i>Next</button>
        </div>

      </div>



    </form>
  </div>
</div>
